module.exports = __webpack_public_path__ + "img/bg.394f9ebc.jpg";